<template>
  <div class="catalog-sort-modal">
    <ModalComponentHeader> {{ messages?.sort }} </ModalComponentHeader>
    <ModalComponentBody>
      <DefRadio
        v-for="item in items"
        name="sort-buttons"
        :checked="item.active || (!getActiveItem && item.sort === 'property_POPULAR')"
        @change="handlerChangeSort(item)"
      >
        <!--повинно бути 2 обробника-->
        <a :href="item.request" rel="nofollow" @click.prevent="handlerChangeSort(item)">
          {{ item.name }}
        </a>
      </DefRadio>
    </ModalComponentBody>
  </div>
</template>

<script lang="ts" setup>
import ModalComponentHeader from '@use/useModal/ModalComponentHeader.vue';
import ModalComponentBody from '@use/useModal/ModalComponentBody.vue';
import { computed } from 'vue';
import DefRadio from '@components/Def/DefRadio/DefRadio.vue';
import { useCatalogStore } from '@/storePinia/stores/catalog';
import useModal from '@use/useModal/useModal';
import { replaceUrl } from '@/utils/location';

const props = defineProps<{ result?: { items?: any[]; messages?: { [key: string]: string } } }>();
const emit = defineEmits(['changeSort']);

const catalogStore = useCatalogStore();
const modal = useModal();

// result передается при использовании вне каталога (например, в кабинете)
const sortData = computed(() => props.result ?? catalogStore.catalogSort);
const messages = computed(() => sortData.value?.messages);
const items = computed(() => sortData.value?.items);

const handlerChangeSort = async (item) => {
  const fullPath = replaceUrl(item.request);

  if (props.result) {
    emit('changeSort', fullPath);
    modal.hide();
    return;
  }

  await catalogStore.changePageData(fullPath);
  modal.hide();
};

const getActiveItem = computed(() => items.value?.find((el) => el.active));
</script>

<style lang="scss" scoped>
.catalog-sort-modal {
  :deep(.modal-component-body) {
    display: grid;
    grid-row-gap: 24px;
  }
}
</style>
